import type {LiveEventRepository} from "../../domain/types";
import {LiveEventRepositoryV2} from "./repository.v2";

export type {LiveEventRepository} from "../../domain/types";

/**
 * Creates the LiveEventRepository (V2 API implementation).
 *
 * @example
 * const repository = createLiveEventRepository();
 * const event = await repository.getById(123);
 */
export const createLiveEventRepository = (): LiveEventRepository => {
  return new LiveEventRepositoryV2();
};
